export interface PointsActivety {
    ruleId: string;
    ruleType: 'EARN' | 'REDEEM' | 'THIRD_COUPONS' | 'FREE_PRODUCTS';
    points: string;
    source: string;
    source2?: string;
    status: string; // FROZEN("冻结中"), REWARDED("已发放"), USED("已使用"), EXPIRED("已失效")
    rewardStatus: 1 | 2 | 3; //(1-冻结中;2-已发放;3-已使用)
    createTime: string;
    createTimeStamp: number;
    validStartTime?: string;
    validEndTime?: string;
    website?: string;
    goodTitle?: string;
    couponName?: string;
}

export interface RewardsActivity {
    amount: number;
    coupon: string;
    createTime: string;
    currencySymbol: string;
    discountType: string;
    id: string;
    ruleType: 'COUPONS' | 'THIRD_COUPONS' | 'FREE_PRODUCTS';
    source: string;
    sourceDesc: string;
    useStatus: 'UNUSED' | 'USED';
    couponName?: string;
    goodTitle?: string;
    variantTitle?: string;
    prizeId?: string;
    prizeName?: string;
}

export enum LevelType {
    RELEGATION = 'RELEGATION', // 会员等级保级
    DEMOTION = 'DEMOTION', // 会员等级降级
    UPGRADE = 'UPGRADE', // 会员等级升级
    REGISTER = 'REGISTER', // 用户注册成为初始会员
    HISTORY_REFRESH_PLUS_MEMBER = 'HISTORY_REFRESH_PLUS_MEMBER', // 历史数据刷新成PLUS会员
    HISTORY_REFRESH_MEMBER = 'HISTORY_REFRESH_MEMBER', // 历史数据刷新成普通会员
}

export interface LevelLogItem {
    createTime: string;
    updateTime: string;
    validEndTime: string;
    type: LevelType;
}
